/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlockUserResponse
 */
export interface BlockUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BlockUserResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof BlockUserResponse
     */
    message: string;
}

/**
 * Check if a given object implements the BlockUserResponse interface.
 */
export function instanceOfBlockUserResponse(value: object): value is BlockUserResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function BlockUserResponseFromJSON(json: any): BlockUserResponse {
    return BlockUserResponseFromJSONTyped(json, false);
}

export function BlockUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function BlockUserResponseToJSON(json: any): BlockUserResponse {
    return BlockUserResponseToJSONTyped(json, false);
}

export function BlockUserResponseToJSONTyped(value?: BlockUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

